module.exports = "pegasus/assets/square-google.gif";